import type { CadastroConfig, TipoCadastro } from '@/types'

export const cadastrosConfig: Record<TipoCadastro, CadastroConfig> = {
  clientes: {
    label: 'Clientes',
    endpoint: '/importacao/clientes',
    endpointProcessar: '/importacao/clientes/processar',
    camposObrigatorios: ['cliente', 'cpf_cnpj', 'uf', 'cidade', 'ende', 'bairro', 'numende', 'cep', 'mod_trib'],
    todosCampos: [
      'cliente', 'sexo', 'dat_nasc', 'cpf_cnpj', 'rg_iest', 'fone', 'tel2', 'tel3',
      'celular', 'homepage', 'email', 'uf', 'cidade', 'ende', 'bairro', 'numende',
      'cep', 'obs', 'fanta', 'mod_trib', 'CODCLI_SISLEGADO'
    ],
    icon: 'mdi-account-group',
    templateFile: 'template_clientes.xlsx',
    notasCampos: {
      mod_trib: 'Obrigatório apenas para CNPJ (pessoa jurídica). Para CPF é definido automaticamente.'
    }
  },
  fornecedores: {
    label: 'Fornecedores',
    endpoint: '/importacao/fornecedores',
    endpointProcessar: '/importacao/fornecedores/processar',
    camposObrigatorios: ['fornecedor', 'cpf_cnpj', 'uf', 'cidade', 'ende', 'bairro', 'numende', 'cep', 'mod_trib'],
    todosCampos: [
      'fornecedor', 'sexo', 'dat_nasc', 'cpf_cnpj', 'rg_iest', 'fone', 'tel2', 'tel3',
      'celular', 'homepage', 'email', 'uf', 'cidade', 'ende', 'bairro', 'numende',
      'cep', 'oco3', 'fanta', 'mod_trib', 'tf', 'comp', 'cls', 'CODFOR_SISLEGADO'
    ],
    icon: 'mdi-truck',
    templateFile: 'template_fornecedores.xlsx',
    notasCampos: {
      mod_trib: 'Obrigatório apenas para CNPJ (pessoa jurídica). Para CPF é definido automaticamente.'
    }
  },
  credores: {
    label: 'Credores',
    endpoint: '/importacao/credores',
    endpointProcessar: '/importacao/credores/processar',
    camposObrigatorios: ['credor', 'cpf_cnpj', 'uf', 'cidade', 'ende', 'bairro', 'numende', 'cep'],
    todosCampos: [
      'credor', 'sexo', 'dat_nasc', 'cpf_cnpj', 'rg_ie', 'fone', 'fone2', 'cel',
      'site', 'email', 'uf', 'cidade', 'ende', 'bairro', 'numende', 'cep',
      'obs', 'fanta', 'CODCRE_SISLEGADO'
    ],
    icon: 'mdi-bank',
    templateFile: 'template_credores.xlsx'
  },
  produtos: {
    label: 'Produtos',
    endpoint: '/importacao/produtos',
    endpointProcessar: '/importacao/produtos/processar',
    camposObrigatorios: ['codpro', 'produto', 'subcod', 'un', 'codcat', 'ncm', 'tp_prod', 'diverso'],
    todosCampos: [
      'codpro', 'produto', 'subcod', 
      'un', 'codcat', 'codref1', 
      'ncm', 'tp_prod', 'diverso'
    ],
    icon: 'mdi-package-variant',
    templateFile: 'template_produtos.xlsx'
  },
  ativos: {
    label: 'Ativos',
    endpoint: '/importacao/ativos',
    endpointProcessar: '/importacao/ativos/processar',
    camposObrigatorios: ['ativo_codigo', 'ativo_descricao', 'ativo_tipo', 'ativo_veicprop'],
    todosCampos: [
      'ativo_codigo', 'ativo_descricao', 'ativo_local',
      'ativo_tipo', 'ativo_veicprop', 'ativo_valativo',
      'ativo_placa', 'ativo_tara', 'ativo_capacidade',
      'ativo_mediapadrao', 'ativo_licenciamento', 'ativo_marca',
      'ativo_modelo', 'ativo_ano', 'ativo_cor',
      'ativo_renavan', 'ativo_chassis', 'ativo_tipoconsumo',
      'ativo_tipoveiculo', 'ativo_tipocacamba'
    ],
    icon: 'mdi-car-cog',
    templateFile: 'template_ativos.xlsx'
  },
}

export const getTipoCadastroList = (): { value: TipoCadastro; config: CadastroConfig }[] => {
  return Object.entries(cadastrosConfig).map(([key, config]) => ({
    value: key as TipoCadastro,
    config
  }))
}

export const getCadastroConfig = (tipo: TipoCadastro): CadastroConfig => {
  return cadastrosConfig[tipo]
}
